export default "__VITE_ASSET__a58b61c7__"